// FILE: src/components/AdminRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth, firestore } from '../firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

function AdminRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      console.log('AdminRoute: Checking authentication...');
      
      // Check for custom authentication first
      const customUser = localStorage.getItem('customUser');
      const customRole = localStorage.getItem('userRole');
      
      console.log('AdminRoute: Custom auth check:', { customUser: !!customUser, customRole });
      
      if (customUser && customRole) {
        const parsedUser = JSON.parse(customUser);
        console.log('AdminRoute: Using custom auth:', parsedUser);
        setUser(parsedUser);
        setUserRole(customRole);
        setLoading(false);
        return;
      }
      
      // Fallback to Firebase Auth
      const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
        console.log('AdminRoute: Firebase auth check:', { user: !!firebaseUser });
        setUser(firebaseUser);
        if (firebaseUser) {
          try {
            const userRef = doc(firestore, 'users', firebaseUser.uid);
            const snap = await getDoc(userRef);
            if (snap.exists()) {
              const role = snap.data().role;
              console.log('AdminRoute: User role:', role);
              setUserRole(role);
            } else {
              console.log('AdminRoute: No user document found');
              setUserRole(null);
            }
          } catch (error) {
            console.error('Error fetching user role:', error);
            setUserRole(null);
          }
        } else {
          setUserRole(null);
        }
        setLoading(false);
      });

      return () => unsubscribe();
    };
    
    checkAuth();
  }, []);

  if (loading || userRole === null) {
    return <div className="p-10 text-center">Checking access...</div>;
  }

  // Allow admin and manager
  if (userRole === 'admin' || userRole === 'manager') {
    console.log('AdminRoute: Access granted for role:', userRole);
    // Pass role as prop to children if possible
    return React.cloneElement(children, { userRole });
  }

  console.log('AdminRoute: Access denied for role:', userRole);
  return <Navigate to="/login" />;
}

export default AdminRoute;
